/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import {
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import BreadCrumb from '../../components/Label/Breadcrumb'
import api from '../../config/AxiosInstance'
import {
  convertDateWithoutTime,
  convertDateWithTime
} from '../../helpers/constants'
import Loading from '../../components/atoms/Loading'
import toast, { Toaster } from 'react-hot-toast'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const StyledDetailField = ({ label, value, col = 3, children, address }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {address ? (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        ) : children ? (
          children
        ) : (
          value
        )}
      </div>
    </Form.Group>
  )
}

const WorkOrderPlanDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [detail, setDetail] = useState([])
  const [target, setTarget] = useState([])
  const [source, setSource] = useState([])
  const [progress, setProgress] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const btnOrange = {
    backgroundColor: 'var(--primary-orange)',
    borderColor: 'var(--primary-orange)',
    color: 'white'
  }

  const fetchDetailWorkOrder = async () => {
    try {
      setIsLoading(true)
      const res = await api.get(`/outbound/work-order/${id}`)
      setDetail(res.data.data)
      setTarget(res.data.data.target)
      setSource(res.data.data.source)
      setProgress(res.data.data.progress_detail)
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setIsLoading(false)
    }
  }

  const cancelWo = () => {
    try {
      Swal.fire({
        title: 'Cancel Wo?',
        text: "Continue? Action cant't be Repeated",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#C12727',
        cancelButtonColor: '',
        confirmButtonText: 'Cancel Wo',
        cancelButtonText: 'Continue Wo',
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          await api.post(`/outbound/work-order/${id}/cancel`)
          fetchDetailWorkOrder()
        }
      })
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const continueWo = () => {
    try {
      Swal.fire({
        title: 'Continue with current stock ?',
        text: "Source qty don't match target qty!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#F89D1D',
        cancelButtonColor: '',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          await api.post(`/outbound/work-order/${id}/continue`)
          fetchDetailWorkOrder()
        }
      })
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  useEffect(() => {
    fetchDetailWorkOrder()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Toaster />
      <Container>
        <Row className="mb-3">
          <Col md={4}>
            <BreadCrumb
              label={detail.wo_code}
              link="/workorder/plan"
              back="WORK ORDER PLAN"
              status={detail.status}
              type={'WorkOrderStatus'}
              stateValue={state}
            />
          </Col>

          {detail.status === 'problem' && (
            <Col md={8} className="text-end">
              <button
                className="btn btn-danger me-3"
                onClick={() => cancelWo()}
              >
                Cancel WO
              </button>
              <button
                className="btn"
                style={btnOrange}
                onClick={() => continueWo()}
              >
                Continue with available source
              </button>
            </Col>
          )}
        </Row>

        <Card style={cardStyle}>
          <Row>
            <StyledDetailField
              label="request time"
              value={detail.request_time}
              col={3}
            />
            <StyledDetailField label="type" value={detail.type} col={3} />
            <StyledDetailField
              label="warehouse"
              value={detail.warehouse}
              col={3}
            />
          </Row>
        </Card>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            TARGET
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  No
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Item Code - Name
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Item Alias
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Batch
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Expired
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Qty@Pack
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Total Qty
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  UOM
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Total Pack
                </th>
              </tr>
            </thead>
            <tbody>
              {target.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="p-2 align-middle">{index + 1}</td>
                    <td className="p-2 align-middle">{`${item.item_code} - ${item.item_name}`}</td>
                    <td className="p-2 align-middle">{item.item_alias}</td>
                    <td className="p-2 align-middle">{item.batch}</td>
                    <td className="p-2 align-middle">
                      {item.exp_date
                        ? convertDateWithoutTime(item.exp_date)
                        : '-'}
                    </td>
                    <td className="p-2 align-middle">{item.qty_pack}</td>
                    <td className="p-2 align-middle">{item.total_qty}</td>
                    <td className="p-2 align-middle">{item.uom}</td>
                    <td className="p-2 align-middle">{item.total_pack}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </Card>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            SOURCE
          </h5>
          <Table responsive hover style={{ fontSize: '13px' }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  No
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Item Code - Name
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Item Alias
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Batch
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Expired
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Total Qty
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Total Pack
                </th>
                <th className="p-2 align-middle" style={tableHeaderStyle}>
                  Location
                </th>
              </tr>
            </thead>
            <tbody>
              {source.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="p-2 align-middle">{index + 1}</td>
                    <td className="p-2 align-middle">{`${item.item_code} - ${item.item_name}`}</td>
                    <td className="p-2 align-middle">{item.item_alias}</td>
                    <td className="p-2 align-middle">{item.batch}</td>
                    <td className="p-2 align-middle">
                      {item.exp_date
                        ? convertDateWithoutTime(item.exp_date)
                        : '-'}
                    </td>
                    <td className="p-2 align-middle">{item.total_qty}</td>
                    <td className="p-2 align-middle">{item.total_pack}</td>
                    <td className="p-2 align-middle">
                      <p
                        onClick={() =>
                          navigate(`/workorder/plan/location`, {
                            replace: true,
                            state: {
                              location: item.locations,
                              code: detail.wo_code,
                              id: detail.id
                            }
                          })
                        }
                        className="text-primary cursor-pointer mb-0 fw-bold"
                        role="button"
                      >
                        {item.location}
                      </p>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </Card>

        <Card style={cardStyle}>
          <h5 className="fw-bold text-uppercase mb-3" style={{ color: '#333' }}>
            PROGRESS DETAIL
          </h5>
          <Collapse in={true}>
            <ul className="list-unstyled mb-0">
              {progress?.length > 0 &&
                progress?.map((item) => (
                  <li key={item.id} className="mb-2">
                    <div className="d-flex flex-row gap-3 progress-detail">
                      <div className="circle-progress-detail"></div>
                      <p
                        className="mb-0 text-muted"
                        style={{ fontSize: '0.9rem', minWidth: '100px' }}
                      >
                        {item.datetime ? item.datetime : '-'}
                      </p>
                      <div
                        className="d-flex flex-column justify-content-center"
                        style={{ height: '20px' }}
                      >
                        <div className="d-flex flex-row gap-3 align-items-center">
                          <div className="circle-small-progress-detail"></div>
                          <span
                            style={{ fontSize: '13px' }}
                            className="fw-bold text-dark"
                          >
                            {item.description}
                          </span>
                        </div>
                      </div>
                    </div>
                    <ul
                      className="list-unstyled"
                      style={{
                        marginLeft: '3.5rem',
                        marginTop: '0px',
                        marginBottom: '8px'
                      }}
                    >
                      {item?.detail?.length > 0 &&
                        item?.detail?.map((detail, index) => (
                          <span
                            key={index}
                            style={{
                              color: detail.color,
                              fontSize: '0.85rem'
                            }}
                          >
                            {detail.description}{' '}
                            {index < item.detail.length - 1 ? ', ' : ''}
                          </span>
                        ))}
                    </ul>
                  </li>
                ))}
            </ul>
          </Collapse>
        </Card>

        <Card style={cardStyle}>
          <Row>
            <StyledDetailField
              label="pnp"
              value={detail.pnp ? detail.pnp : '-'}
              col={6}
            />
            <StyledDetailField
              label="rnr"
              value={detail.rnr ? detail.rnr : '-'}
              col={6}
            />
          </Row>
          <hr className="my-3" />
          <Row>
            <StyledDetailField
              label="created by"
              value={detail.created_by}
              col={3}
            />
            <StyledDetailField
              label="created at"
              value={convertDateWithTime(detail.created_at)}
              col={3}
            />
            <StyledDetailField
              label="last update by"
              value={detail.last_updated_by ? detail.last_updated_by : '-'}
              col={3}
            />
            <StyledDetailField
              label="last update at"
              value={
                detail.last_updated_at
                  ? convertDateWithTime(detail.last_updated_at)
                  : '-'
              }
              col={3}
            />
          </Row>
        </Card>
      </Container>
    </>
  )
}

export default WorkOrderPlanDetail
